import includes from 'lodash/includes'

function is_us_territory(state) {
  const us_territories = [
    'American Samoa',
    'Guam',
    'Northern Mariana Islands',
    'Puerto Rico',
    'United States Minor Outlying Islands',
    'Virgin Islands, U.S.'
  ]
  return includes(us_territories, state)
}

function is_military_address(state) {
  const us_territories = [
    'Armed Forces Americas',
    'Armed Forces Europe',
    'Armed Forces Pacific'
  ]
  return includes(us_territories, state)
}

function is_PO_box(address_line) {
  const regex = /^P\.?O\.? Box/i
  return regex.test(address_line)
}

function is_taxable_country(country) {
  const taxable_countries = [
    'United States of America',
    'Australia',
    'Canada',
    // EU Countries
    'Austria',
    'Belgium',
    'Bulgaria',
    'Croatia',
    'Cyprus',
    'Czech Republic',
    'Denmark',
    'Estonia',
    'Finland',
    'France',
    'Germany',
    'Greece',
    'Hungary',
    'Ireland',
    'Italy',
    'Latvia',
    'Lithuania',
    'Luxembourg',
    'Malta',
    'Netherlands',
    'Poland',
    'Portugal',
    'Romania',
    'Slovakia',
    'Slovenia',
    'Spain',
    'Sweden',
    // Not in EU but still taxable
    'United Kingdom of Great Britain and Northern Ireland'
  ]
  return includes(taxable_countries, country)
}

function in_central_america(country) {
  const countries = [
    'Belize',
    'Costa Rica',
    'El Salvador',
    'Guatemala',
    'Honduras',
    'Mexico',
    'Nicaragua',
    'Panama',
  ]
  return includes(countries, country)
}

function in_south_america(country) {
  const countries = [
    'Argentina',
    'Bolivia (Plurinational State of)',
    'Brazil',
    'Chile',
    'Colombia',
    'Ecuador',
    'Falkland Islands (Malvinas)',
    'French Guiana',
    'Guyana',
    'Paraguay',
    'Peru',
    'Suriname',
    'Uruguay',
    'Venezuela (Bolivarian Republic of)',
  ]
  return includes(countries, country)
}

function in_european_union(country) {
  const countries = [
    'Austria',
    'Belgium',
    'Bulgaria',
    'Croatia',
    'Cyprus',
    'Czech Republic',
    'Denmark',
    'Estonia',
    'Finland',
    'France',
    'Germany',
    'Greece',
    'Hungary',
    'Ireland',
    'Italy',
    'Latvia',
    'Lithuania',
    'Luxembourg',
    'Malta',
    'Netherlands',
    'Poland',
    'Portugal',
    'Romania',
    'Slovakia',
    'Slovenia',
    'Spain',
    'Sweden',
  ]
  return includes(countries, country)
}

export {
  is_us_territory,
  is_military_address,
  is_PO_box,
  is_taxable_country,
  in_central_america,
  in_south_america,
  in_european_union
}
